import { styled } from "@mui/material/styles";
export const ellipsisStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};
export const noWrapStyle = {
    whiteSpace: "nowrap",
};
export const Ellipsis = styled("span")({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
});
//# sourceMappingURL=Ellipsis.js.map